import React, { createContext, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notify, setNotify] = useState({
    open: false,
    message: "",
    type: "", // success | error | warning | info
  });

  const showNotification = (message, type) => {
    setNotify({ open: true, message, type });
  };

  const handleClose = () => {
    setNotify({ ...notify, open: false });
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}

      {/* Snackbar */}
      <Snackbar
        open={notify.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            border: "2px solid #1976d2",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          },
        }}
      >
        <Alert
          onClose={handleClose}
          severity={notify.type}
          variant="filled"
          sx={{
            fontSize: "15px",
            fontWeight: 600,
            borderRadius: "10px",
            bgcolor: "#1976d2",
            color: "#fff",
          }}
        >
          {notify.message}
        </Alert>
      </Snackbar>

      <Snackbar
        open={notify.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          },
        }}
      >
        <Alert
          onClose={handleClose}
          severity={notify.type}
          variant="filled"
          sx={{
            fontSize: "15px",
            fontWeight: 600,
            borderRadius: "10px",
            color: "#fff",
          }}
        >
          {notify.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};
